import { BottomSheetIllustrationContent } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { Button } from "../../../components/Button";
import { DialogFooter } from "../../../components/DialogFooter";
import { type Facility } from "../../data/schemas";

interface SuccessScreenProps {
  facility: Facility;
  onClose: () => void;
}

export function SuccessScreen({ facility, onClose }: SuccessScreenProps) {
  return (
    <Stack>
      <BottomSheetIllustrationContent
        illustrationType="success"
        title="Interest Submitted!"
        description={`Thank you for expressing interest in ${facility.name}. We'll reach out when this facility becomes available on Clipboard Health.`}
      />

      <DialogFooter orientation="vertical">
        <Button fullWidth variant="contained" size="large" onClick={onClose}>
          Done
        </Button>
      </DialogFooter>
    </Stack>
  );
}
